import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from 'src/app/core/services/nav.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})
export class CookieComponent {
 public constructor(@Inject(LOCALE_ID) public locale: string,  private navSrv: NavService, private router: Router) {
    navSrv.clearBreadcrumbs();
    let str_array:any ={"si":"Cookie Notice","en":"Cookie Notice","ta":"Cookie Notice"} 
    let tmp  = str_array[locale]
    this.navSrv.setCrumb(tmp, "about-us", true)
  }
}
